module.exports = __webpack_public_path__ + "media/images/menu-3f3678abf9272ea36e200fcf477f78ea.png";